import { SITE } from '@maktech/shared';

/**
 * WhatsApp + call float buttons (spec 7.2).
 *
 * Ported from waUs()/callUs() (index.html:3969/:3968). callUs() only raised a
 * toast; a tel: link actually dials, which is the real intent on the mobile
 * traffic this serves.
 */
export function ContactFloats() {
  return (
    <div className="floats" aria-label="Contact us">
      <a
        className="float-btn float-wa"
        data-testid="float-whatsapp"
        href={`https://wa.me/${SITE.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Message us on WhatsApp"
        title={`WhatsApp +${SITE.whatsapp}`}
      >
        💬
      </a>
      <a
        className="float-btn float-call"
        data-testid="float-call"
        href={`tel:${SITE.hotline}`}
        aria-label={`Call ${SITE.hotline}`}
        title={`Call ${SITE.hotline}`}
      >
        ☎
      </a>
    </div>
  );
}
